import { FiltersType } from "components/Shared/GlobalFilter/context/interfaces"

import { RequestParameters } from "components/Shared/Filters/interfaces"

export const getLastSelectorWithValue = (filters: FiltersType) => {
	const orderConfig: Array<keyof RequestParameters> = [
		"fineline",
		"subcategories",
		"categories",
		"departments",
	]

	const filterSelected = orderConfig.find(
		(filterId) => filters[filterId]?.length > 0
	)

	if (!filterSelected) {
		return undefined
	}

	const [firstOption] = filters[filterSelected]

	return {
		description: firstOption.name,
		name: filterSelected,
	}
}
